import PropTypes from 'prop-types';

import RadioGroupMui from '@mui/material/RadioGroup';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import Stack from '@mui/material/Stack';
import FormHelperText from '@mui/material/FormHelperText';

const RadioGroup = (props) => {
	const {
		name,
		label,
		group,
		value,
		error,
		helperText,
		onChange,
		options = [],
	} = props;

	return (
		<Stack spacing={1}>
			{label && <InputLabel>{label}</InputLabel>}
			<FormControl>
				<RadioGroupMui
					name={name}
					value={value}
					onChange={onChange}
					sx={{ pl: 0.5 }}
					{...group}
				>
					{options.map((option) => {
						return (
							<FormControlLabel
								key={option.value}
								value={option.value}
								label={option.label}
								control={
									<Radio
										sx={{ color: error ? 'error.main' : undefined }}
										color={error ? 'error' : undefined}
										{...option.radio}
									/>
								}
							/>
						);
					})}
				</RadioGroupMui>
				{helperText && <FormHelperText>{helperText}</FormHelperText>}
				{typeof error === 'string' && error && (
					<FormHelperText error>{error}</FormHelperText>
				)}
			</FormControl>
		</Stack>
	);
};

RadioGroup.propTypes = {
	name: PropTypes.string,
	error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
	helperText: PropTypes.string,
	label: PropTypes.string,
	onChange: PropTypes.func,
	group: PropTypes.shape(RadioGroupMui.propTypes),
	value: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.number,
		PropTypes.bool,
	]),
	options: PropTypes.arrayOf(
		PropTypes.shape({
			value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
			label: PropTypes.node,
			radio: PropTypes.shape(Radio.propTypes),
		}),
	),
};

export default RadioGroup;
